var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRegionalSalonais(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 200 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#0059a1;}.cls-2{fill:#e20613;}.cls-3{fill:#fbfbfb;}.cls-4{fill:#fdfdfc;}.cls-5{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "REGIO"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 0.33,
    y: 20.18,
    width: 199.34,
    height: 44.92
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 0.33,
    y: 65.82,
    width: 199.34,
    height: 14
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M55.4,60.05c-2.73,4.22-6,5.77-10.33,5.77-7.3,0-11.77-6.54-11.77-14.62,0-8.62,5.06-14.62,11.92-14.62,6.55,0,11,5.35,11,14.56v1.48H37.47c.3,4.82,3.38,8.92,7.6,8.92,3.32,0,5.56-1.43,7.4-4.22ZM52.07,48.7c-.15-4.69-2.73-7.84-7-7.84S38,44,37.47,48.7ZM46.51,22.08H52l-7.1,8.56H41.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M85.45,63.86c0,10-4.52,15.5-12.67,15.5a13.84,13.84,0,0,1-11.42-5.28l2.78-3.81c2.43,3.15,5.06,4.82,8.64,4.82,7,0,8.79-5.35,8.79-11.23V60.29h-.1a9.15,9.15,0,0,1-8.19,5.17c-7.3,0-12.37-6.06-12.37-14.26,0-9.09,5-14.62,12.37-14.62a8.9,8.9,0,0,1,8.19,5.47h.1V37.29h3.88ZM73.28,61.18c5.31,0,8.29-4.75,8.29-10.1,0-6-3.38-10.22-8.29-10.22s-8.2,4.52-8.2,10.34C65.08,56.84,68.76,61.18,73.28,61.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M94.88,23a3.15,3.15,0,0,1,2.83,3.39c0,2-1.19,3.39-2.83,3.39s-2.83-1.43-2.83-3.39A3.15,3.15,0,0,1,94.88,23ZM92.94,37.29h3.88V65.1H92.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M115.59,36.58c7.15,0,12.42,5.94,12.42,14.62s-5.27,14.62-12.42,14.62-12.41-5.95-12.41-14.62S108.44,36.58,115.59,36.58Zm0,25c5,0,8.25-4.52,8.25-10.34s-3.23-10.34-8.25-10.34-8.24,4.52-8.24,10.34,3.23,10.3,8.24,10.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M134,43.89c0-2.56-.2-4.75-.2-6.6h3.67c0,1.49.1,3,.1,4.58h.1a8.39,8.39,0,0,1,7.75-5.29c6.11,0,8.84,4.64,8.84,11.35V65.1h-3.87V48.41c0-4.64-1.69-7.55-5.32-7.55-5,0-7.2,4.34-7.2,10.69V65.1H134Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M161.33,40.86a11.88,11.88,0,0,1,9.24-4.28c6.85,0,9.74,3.92,9.74,11.77V60.29a36.79,36.79,0,0,0,.34,4.81h-3.72a23.19,23.19,0,0,1-.25-4.16h-.1a8.55,8.55,0,0,1-7.65,4.88c-4.72,0-8.64-2.86-8.64-8.26,0-9.21,8.94-9.75,14.65-9.75h1.49V47c0-4-2.13-6.12-5.76-6.12a9.36,9.36,0,0,0-6.9,3Zm11.23,10.87c-4.92,0-8.1,1.61-8.1,5.35,0,3.51,2.19,4.81,5.12,4.81,4.47,0,6.75-3.86,6.85-8.37V51.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M187.76,20.18h3.87V65.1h-3.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M19.19,45.73c5.47-1,8.79-5,8.79-11.11,0-9-5.46-11.12-11.36-11.51A11.37,11.37,0,0,1,18,27.9c3,.53,5.47,2.16,5.47,6.72,0,7-6,7-10.63,7H9.16v-3H5V65.1H9.16V46.21h5.36L24.06,65.1h5.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M6.2,34.46h3v1.23H5V23.8H6.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M9.93,30.06c0,2.19.91,4,2.21,4,1,0,1.61-1,2-2.45l1,1c-.65,2.12-1.74,3.33-3.11,3.33-2,0-3.3-2.7-3.3-6.11S9.92,23.36,12,23.36s3.31,3.16,3.2,6.7ZM14,28.34c-.16-1.72-1-3.11-2-3.11s-1.91,1.39-2,3.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M94,75.2h2.1V76h-3V68.68H94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M97.35,68.81l-1.16,2.46-.54-.2.95-2.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M99,68v4h0a1.62,1.62,0,0,1,1.36-.68c1.31,0,1.62.91,1.62,2V76h-.81V73.39c0-.73-.06-1.39-1-1.39S99,73,99,73.8V76h-.81V68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M103.46,73.85A1.5,1.5,0,0,0,105,75.36h0a1.61,1.61,0,0,0,1.44-.93l.69.37a2.67,2.67,0,1,1,.1-1.28,1.82,1.82,0,0,1,0,.33Zm2.88-.66A1.45,1.45,0,0,0,105,72a1.49,1.49,0,0,0-1.45,1.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M107.76,68h.8v4.07h0a2.1,2.1,0,0,1,1.63-.77,2.4,2.4,0,0,1,0,4.79,2,2,0,0,1-1.64-.76h0V76h-.8Zm.76,5.65A1.58,1.58,0,0,0,110,75.36h.11a1.58,1.58,0,0,0,1.6-1.54c0-.06,0-.11,0-.17A1.56,1.56,0,0,0,110.2,72h-.13a1.58,1.58,0,0,0-1.55,1.61v0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M116.65,75.32h0a2,2,0,0,1-1.64.76,2.4,2.4,0,0,1,0-4.79,2.1,2.1,0,0,1,1.63.77h0V68h.81v8h-.81Zm-3.1-1.68A1.6,1.6,0,0,0,115,75.36h.1a1.58,1.58,0,0,0,1.6-1.54c0-.06,0-.11,0-.17A1.55,1.55,0,0,0,115.24,72h-.15a1.57,1.57,0,0,0-1.54,1.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M118,73.69a2.5,2.5,0,1,1,2.61,2.39h-.11A2.44,2.44,0,0,1,118,73.7Zm.81,0A1.69,1.69,0,1,0,120.52,72a1.64,1.64,0,0,0-1.69,1.59v.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M129.76,75.32h0a2,2,0,0,1-1.64.76,2.4,2.4,0,0,1,0-4.79,2.1,2.1,0,0,1,1.63.77h0V68h.81v8h-.81Zm-3.1-1.68a1.6,1.6,0,0,0,1.45,1.72h.1a1.58,1.58,0,0,0,1.6-1.54c0-.06,0-.11,0-.17A1.55,1.55,0,0,0,128.35,72h-.15a1.57,1.57,0,0,0-1.54,1.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M132.31,73.94c0,.77.09,1.42,1.07,1.42s1.07-.65,1.07-1.42V71.42h.81V74c0,1.21-.48,2-1.88,2s-1.88-.84-1.88-2V71.42h.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M139.69,76h-.85V68.68h1.25a3.36,3.36,0,0,1,1.89.38,2,2,0,0,1,.54,2.78,2.12,2.12,0,0,1-.41.44,2.78,2.78,0,0,1-1.81.49h-.61Zm0-3.94h.56c.94,0,1.74-.27,1.74-1.31s-1-1.27-2-1.27h-.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M147.75,76h-.81v-.63h0a2,2,0,0,1-1.63.76,2.4,2.4,0,0,1,0-4.79,2.08,2.08,0,0,1,1.62.77h0v-.64h.81Zm-3.91-2.31a1.58,1.58,0,0,0,1.45,1.71h.11A1.57,1.57,0,0,0,147,73.88a1.77,1.77,0,0,0,0-.23A1.55,1.55,0,0,0,145.55,72h-.16a1.58,1.58,0,0,0-1.55,1.61v.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M148,71.42h.94l1.68,3.25,1.54-3.25H153l-3.51,7.08h-.92l1.54-3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M155.19,72.47a.75.75,0,0,0-.65-.47.56.56,0,0,0-.58.51c0,.41.54.57,1.1.79s1.1.54,1.1,1.3a1.53,1.53,0,0,1-1.58,1.48h0a1.69,1.69,0,0,1-1.67-1.15l.71-.29a1,1,0,0,0,1,.72.72.72,0,0,0,.77-.65v0c0-1-2.14-.67-2.14-2.1a1.33,1.33,0,0,1,1.38-1.28h0a1.43,1.43,0,0,1,1.27.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M162.86,70.09a1.39,1.39,0,0,0-1.31-.79,1.2,1.2,0,0,0-1.27,1.13h0c0,.63.68.92,1.2,1.14l.5.21c1,.42,1.83.89,1.83,2A2.31,2.31,0,0,1,161.44,76h0A2.33,2.33,0,0,1,159,74.2l.83-.23a1.54,1.54,0,0,0,1.53,1.35A1.48,1.48,0,0,0,163,74a.22.22,0,0,0,0-.08c0-.85-.69-1.14-1.4-1.45l-.47-.19c-.89-.39-1.66-.82-1.66-1.87a2,2,0,0,1,2.14-1.85h0a2.2,2.2,0,0,1,2,1.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M168.89,76h-.81v-.63h0a2,2,0,0,1-1.64.76,2.4,2.4,0,0,1,0-4.79,2.1,2.1,0,0,1,1.63.77h0v-.64h.81ZM165,73.64a1.58,1.58,0,0,0,1.45,1.71h.11a1.58,1.58,0,0,0,1.6-1.54c0-.06,0-.11,0-.17A1.56,1.56,0,0,0,166.68,72h-.13A1.58,1.58,0,0,0,165,73.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M170.66,76h-.8V68h.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M171.24,73.69a2.5,2.5,0,1,1,2.61,2.39h-.11a2.44,2.44,0,0,1-2.5-2.38Zm.81,0A1.69,1.69,0,1,0,173.74,72a1.64,1.64,0,0,0-1.69,1.59v.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M177.65,72h0a1.6,1.6,0,0,1,1.35-.68c1.32,0,1.62.91,1.62,2V76h-.81V73.39c0-.73-.06-1.39-1-1.39-1.11,0-1.18,1-1.18,1.8V76h-.81V71.42h.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M186,76h-.81v-.63h0a2,2,0,0,1-1.64.76,2.4,2.4,0,0,1,0-4.79,2.1,2.1,0,0,1,1.63.77h0v-.64H186Zm-3.91-2.31a1.58,1.58,0,1,0,3.14.35,2,2,0,0,0,0-.35,1.57,1.57,0,0,0-3.14,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M188.13,69.71a.58.58,0,1,1-.61-.55h0A.57.57,0,0,1,188.13,69.71ZM188,76h-.81V71.42H188Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M191.06,72.47a.75.75,0,0,0-.65-.47.56.56,0,0,0-.58.51c0,.41.54.57,1.1.79s1.1.54,1.1,1.3a1.53,1.53,0,0,1-1.58,1.48h0a1.69,1.69,0,0,1-1.67-1.15l.71-.29a1,1,0,0,0,1,.72.72.72,0,0,0,.77-.65v0c0-1-2.14-.67-2.14-2.1a1.33,1.33,0,0,1,1.38-1.28h0a1.43,1.43,0,0,1,1.26.84Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRegionalSalonais);
export default __webpack_public_path__ + "static/media/regional-salonais.9bfcd5ce564ffa11ac2c2b866923cb0b.svg";
export { ForwardRef as ReactComponent };